import { Box, Button, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { SvgArrowNarrowLeftFill, SvgChevronLeftFill } from '../SvgIcons';


export default function ButtonBack({
   primary,
   children,
   size = 'large',
   variant = 'h6',
   fontSize,
   spacing = 2,
   borderColor,
   width,
   onClick,
   ...other
}) {
  return (
    <Button
      color={'primary'}
      variant={'outlined'}
      onClick={onClick}
      disableTouchRipple
      disableFocusRipple
      disableElevation
      size={size}
      startIcon={<SvgChevronLeftFill color={'#204ACE'} />}
      sx={{
        p: theme => theme.spacing(1.25, 3),
        position:'relative',
        overflow: 'hidden',
        borderRadius: 0,
        maxHeight: 40,
        ...(width ? { width } : {}),
        ...(borderColor ? { borderColor } : {}),
        // backgroundColor: theme => alpha(theme.palette.color.primaryBlue2, 0.04),
        '.MuiButton-startIcon': {
          marginRight: spacing,
          transition: 'opacity 0.6s, transform 0.8s',
          transitionTimingFunction: 'cubic-bezier(0.15, 0.85, 0.31, 1)'
        },
        '&:hover': {
          // backgroundColor: theme => alpha(theme.palette.color.primaryBlue2, 0.04),
          '&>.MuiBox-root': {
            // transform: 'translateY(-150%)',
            '& .MuiTypography-root': {
              '&:nth-of-type(1)': {
                // opacity: 0
              },
              '&:nth-of-type(2)': {
                transform: 'translate(-50%, 100%)',
                opacity: 1
              }
            }
          },
          '& .MuiButton-startIcon': {
            // transform: 'rotate(45deg)',
            animation: 'toLeftFromRight .3s forwards',
          }
        },
      }}
      { ...other }
    >
      <Box sx={{
        transition: 'opacity 0.6s, transform 0.8s',
        transitionTimingFunction: 'cubic-bezier(0.15, 0.85, 0.31, 1)',
      }}>
        <Typography
          display={'inline-block'}
          width={`100%`}
          variant={variant}
          fontSize={fontSize}
          sx={{
            transition: 'opacity 0.6s, transform 0.8s',
            transitionTimingFunction: 'cubic-bezier(0.15, 0.85, 0.31, 1)',
          }}>{primary || children}</Typography>

        <Typography display={'inline-block'} variant={variant} fontSize={fontSize} position={'absolute'} top={`50%`} left={`50%`} width={`100%`} height={`100%`} sx={{
          transition: 'opacity 0.6s, transform 0.8s',
          transitionTimingFunction: 'cubic-bezier(0.15, 0.85, 0.31, 1)',
          transform: 'translate(-50%, 80%)',
          opacity: 0,
        }}>{primary || children}</Typography>
      </Box>
    </Button>
  )
}
